cv.ShareBehavior = Marionette.Behavior.extend({
  // you can set default options
  // just like you can in your Backbone Models
  // they will be overriden if you pass in an option with the same key
  defaults: {
  },

  // behaviors have events that are bound to the views DOM
  events: {
    'click .share-url' : 'shareURL',
    'click .copy-share-url' : 'shareURL',
    'click .share-email' : 'share',
    'click .share-facebook' : 'share',
    'click .share-messenger' : 'share',
    'click .share-twitter' : 'share',
    'click .share-google' : 'share',
    'click .share-pinterest' : 'share',
    'click .share-tumblr' : 'share',
    'click .share-linkedin' : 'share'
  },

  collectionEvents: {
  },

  initialize: function(){
    this.url = '';
    this.title = '';
    this.description = '';
    this.image = '';
    this.window = null;

    console.log('ShareBehavior initialized.');
  },

  isCrossOriginFrame: function() {
    try {
      return (document.location.hostname !== window.parent.location.hostname);
    } catch (e) {
      return true;
    }
  },

  shareURL: function(e){
    e.preventDefault();
  },

  share: function(e){
    e.preventDefault();

    if(this.isCrossOriginFrame()){
      var network = $(e.currentTarget).prop('class').split('-')[1];

      // Trigger iframe loaded
      window.parent.postMessage({
        type : 'share_info',
        network : network
      }, "*");

      return false;
    }

    this.url = $(e.currentTarget).data('url');
    if(_.isUndefined(this.url)){
      this.url = top.location;
    }
    this.url = top.location.protocol + '//' + this.url;
    this.window = window.open("","_blank");

    $.ajax({
      url: cv.api_path + '/campaigns/share_info?url=' + encodeURIComponent(this.url),
      dataType: "json",
      type: 'get',
      success: _.bind(function(data){
        this.title = data.title;
        this.description = data.description;
        this.image = data.image;
        this.appeal = data.appeal;

        if($(e.currentTarget).hasClass('share-facebook')){
          this.shareFacebook();
        }
        if($(e.currentTarget).hasClass('share-messenger')){
          this.shareMessenger();
        }
        if($(e.currentTarget).hasClass('share-twitter')){
          this.shareTwitter();
        }
        if($(e.currentTarget).hasClass('share-google')){
          this.shareGoogle();
        }
        if($(e.currentTarget).hasClass('share-pinterest')){
          this.sharePinterest();
        }
        if($(e.currentTarget).hasClass('share-tumblr')){
          this.shareTumblr();
        }
        if($(e.currentTarget).hasClass('share-linkedin')){
          this.shareLinkedIn();
        }
        if($(e.currentTarget).hasClass('share-email')){
          this.shareEmail();
        }
      }, this)
    });
  },

  shareFacebook: function(){
    this.window.location.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.url);
  },

  shareMessenger: function(){
    this.window.location.href = 'http://www.facebook.com/dialog/send?app_id=123520134333534&link=' + encodeURIComponent(this.url) + '&redirect_uri=' + encodeURIComponent(this.url);
  },

  shareTwitter: function(){
    this.window.location.href = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(this.url) + '&text='  + encodeURIComponent(this.title);
  },

  sharePinterest: function(){
    this.window.location.href = 'https://www.pinterest.com/pin/create/button/?url=' + encodeURIComponent(this.url);
  },

  shareGoogle: function(){
    this.window.location.href = 'https://plus.google.com/share?url=' + encodeURIComponent(this.url);
  },

  shareLinkedIn: function(){
    this.window.location.href = 'https://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(this.url + '?' + (Math.floor(Math.random()*90000) + 10000)) + '&title=' + encodeURIComponent(this.title) + '&summary=' + encodeURIComponent(this.description) +  '&source=' + encodeURIComponent(this.url);
  },

  shareTumblr: function(){
    this.window.location.href = 'https://www.tumblr.com/widgets/share/tool?posttype=link&amp;title=' + encodeURIComponent(this.url) + '&amp;caption=' + encodeURIComponent(this.title) + '&amp;content=' + encodeURIComponent(this.description) + '&amp;canonicalUrl=' + encodeURIComponent(this.url) + '&amp;shareSource=tumblr_share_button';
  },

  shareEmail: function(){
    if(this.appeal != ''){
      this.window.location.href = 'mailto:?subject=' + encodeURIComponent(this.title) + '&body=' + encodeURIComponent(this.appeal) + '%0A%0A' + encodeURIComponent(this.url);
    }else{
      this.window.location.href = 'mailto:?subject=' + encodeURIComponent(this.title) + '&body=' + encodeURIComponent(this.description) + '%0A%0A' + encodeURIComponent(this.url);
    }
  },
});